import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = [
    "source",
    "button",
    "icon"
  ]

  connect() {
  }

  copy(event) {
    // prevent the default action of the trigger element
    event.preventDefault()
    const copiedText = this.sourceTarget.dataset.clipboardText;
    // copy the content from the sourceTarget to the clipboard
    navigator.clipboard.writeText(copiedText);

    const copiedClass = this.buttonTarget.dataset.clipboardActiveClass;
    const hoverClasses = this.buttonTarget.dataset.clipboardHoverClasses;
    this.buttonTarget.classList.add(copiedClass);
    this.buttonTarget.classList.remove(...hoverClasses.split(' '));

    this.iconTarget.classList.add('swap-active');

    setTimeout(() => {
      this.buttonTarget.classList.remove(copiedClass);
      this.buttonTarget.classList.add(...hoverClasses.split(' '));
      this.iconTarget.classList.remove('swap-active');
    }, 500)
  }
}
